import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, serverTimestamp } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Configuration Firebase avec les bonnes clés pour le projet voyage-90955
const firebaseConfig = {
  apiKey: "AIzaSyDcaj9_x6bNGU_kQOAcKMMuwV-74rBn7jQ",
  authDomain: "voyage-90955.firebaseapp.com",
  projectId: "voyage-90955",
  storageBucket: "voyage-90955.appspot.com",
  messagingSenderId: "1045427771918",
  appId: "1:1045427771918:web:a9c9e5c5f2a8e8b8d7c6b5",
  measurementId: "G-MEASUREMENT_ID"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);
const db = firestore; // Alias pour la compatibilité
const storage = getStorage(app);

// Fonction timestamp pour la compatibilité
const timestamp = (date) => {
  if (date) {
    return date;
  }
  return serverTimestamp();
};

export { app, auth, firestore, db, storage, timestamp };
